export const ERROR_MESSAGES = {

  /* ----------------------------- AUTHENTICATION ----------------------------- */
  NO_AUTH_TOKEN_FOUND: 'No auth token found.',
  AUTHENICATION__FAILED: 'Authentication failed.',
  INVALID_CREDENTIALS: 'Invalid Credentials',
  SESSION_EXPIRED: 'Session Expired. Please Login Again.',
  FAILED_REFRESH_TOKEN: 'Failed to refresh access token: ',
  LOGIN_ERROR: 'Login Error',
  LOGIN_SUCCESS: 'Login Success',
  PLEASE_WAIT: "Please wait",
  SOMETHING_WRONG: 'Something Went Wrong !',
  LOGOUT_FAILED: 'Logout Failed !',
  LOGIN_SUCCESSFULLY : 'Login Successfully',

  /* -------------------------------- PASSWORD -------------------------------- */
  FAILED_TO_UPDATE_PASSWORD: 'Failed to update password.',
  INVALID_PASSWORD_REGX: 'Invalid password regex in .env:',
  INCORRECT_CURRENT: "Incorrect Current Password",
  MUST_MATCH: "Passwords must match",
  FORCE_PASSWORD_CHANGE: "Force Password Change Success",
  PASSWORD_CHANGE: 'Password Change Successfully',

  /* ---------------------------------- OTP ----------------------------------- */
  INAVLID_OTP: "Invalid OTP",
  OPT_FORMAT: (formatted: string) =>
    `You can request a new OTP in ${formatted} second(s)`,

  /* ---------------------------- AUTH / DASHBOARD ----------------------------- */
  DASHBOARD_REDIRECTING: "Redirecting to dashboard...",

  /* ------------------------------- FILE ERRORS ------------------------------- */
  FILE_DOWNLOAD_FAILED: 'File download failed.',
  FAILED_TO_DOWNLOAD: 'Failed to download.',
  FAILED_TO_FETCH_FILE: 'Failed to fetch file.',
  DOWNLOAD_FAILED: 'Download failed',
  FILE_LARGE: 'File too large',
  MAX_FILE_SIZE: 'Maximum file size is 2MB',
  FILE_TOO_LAREG: (fileSize: string) =>
    `File is too large. Max size is ${fileSize} KB.`,
  FILE_NOT_ACCEPT: 'File not accepted.',
  FAILED_UPLOAD_FILE: 'Fail to upload file',
  MISSING_FILE: 'Missing File',
  ERROR_DELETING_FILE: 'Error deleting file:',
  FAILED_DELETED_IMAGE: 'Failed to delete image.',
  PROFILE_PICTURE_REMOVE: "Profile picture removed.",
  FILE_UPLOAD: 'File Uploaded',
  FILE_UPLOAD_SUCCESSFULLY: 'File Uploaded Successfully',

  /* ------------------------------- USER / ENTITY ------------------------------ */
  NO_ENTITY_SELECTED: 'No entity selected.',
  FAILED_UPDATED_PROFILE: 'Failed to update profile',
  ENTITY_FAILED: 'Failed to create Entity:',
  ENTITY_DELETE: 'Entity deleted successfully',
  RECORD_DELETE: 'Records deleted successfully',
  MODEL_DELETE: 'Model Deleted',
  MODEL_DELETE_SUCCESSFULLY: (modelName: string) =>
    `Model ${modelName} has been deleted successfully`,
  DELETE_FAIELD: "Delete Failed",
  EMAIL_ALREADY_TAKEN: 'Email is already taken,',
  UPDATED: 'Updated',
  SETTING_UPDATED: 'Settings updated',
  USER_REGISTER : 'User Registered',
  NO_CHANGE : 'No Change',
  NO_SETTING_UPDATE : 'No settings were updated',
  UPDATING_USER : 'Error updating user view:',

  /* ---------------------------- RELATION & FILTER ---------------------------- */
  INVALID_FILTER_STRUCTURE: 'Invalid filter structure.',
  INVALID_RELATION_TYPE: (relationType: string, fieldName: string) =>
    `Invalid relationType ${relationType} on field ${fieldName}`,
  INVALID_JSON_WHERECLAUSE: 'Invalid whereClause JSON:',
  FIXED_FILTER_NOT_APPLIED: 'Fixed filter not applied due to parsing issues or invalid data.',
  SELECT_RELEVANT_FIELD: 'Please select relevant fields used in fixed filter',
  SKIPPING_EMPTY_FIXED_FILTER: 'Skipping invalid/empty fixed filter : ',
  FIELD_NOT_SELECT: 'Fields Not selected!',
  FIELD_NOT_IN_METADATA: (label: string) =>
    `${label} is not present in metadata`,
  SAVE_FILTER_UNDEFINED_NULL: 'Saved filter ID is undefined or null.',

  /* -------------------------------- FORM / UI -------------------------------- */
  FAILED_UPDATE_FROM: "Failed to update the form.",
  UPDATING_STEPPER: 'Error updating stepper : ',
  DYNAMIC_FUNCTION_ERROR: 'Error in DynamicFunctionComponent : ',
  ON_FORM_LOAD: 'Error in onFormLoad handler:',
  UNABLE_LOAD_DYNAMIC_MODULE: 'Unable to load dynamic module: ',
  LOADING_COMPONENT: 'Error loading component',
  FORM_LAYOUT_UPDATE : 'Form Layout Updated successfully!',
  LAYOUT  : 'Layout',
  MARK_PUBLISH : 'Marked as publish !',
  MARK_UNPUBLISH : 'Marked as unpublish !',
  SAVED : 'Saved',
  FORM_UPDATE : 'Form Updated',
  FORM_UPDATE_SUCCESSFULLY : 'Form updated successfully!',
  FORM_SAVED : 'Form Saved',
  FORM_SAVED_SUCCESSFULLY : 'Form saved successfully!',
  PROFILE_SAVED : 'Profile Saved',
  PROFILE_SAVED_SUCCESSFULLY : 'Profile saved successfully!',
  NO_UPDATE_MADE :'No updates were made.',
  


  /* ------------------------------ INTERACTIONS ------------------------------ */
  INTERATCTION_MESSGAE: (message: string, err: any) =>
    `Error handling interaction.message: ${message || String(err)}`,
  APPLY_FAILED: 'Apply Failed',
  APPLY_SUCCESS: 'Apply Successful',
  PREVIEW_INTERACTION: 'Preview clicked for interaction:',
  FAILED_APPLY_INTERACTION: (error: string) =>
    `Failed to apply interaction - ${error}`,

  /* --------------------------- PROCESS / BACKEND ---------------------------- */
  BACKEND_UNAVAILABLE: 'Backend Unavailable',
  SEEDER_NOT_TRIGGERED: 'Seeder not triggered. Could not reach backend.',
  IS_SEEDER_ERROR: 'isSeederError',
  IS_SEEDER_SUCCESS: 'isSeederSuccess',
  SEEDER_ERROR: 'Seeder Error',
  SEEDER_NOT_RUN: 'Could not run seeder. Please try again.',
  BACKEND_NOT_ALIVE: 'Backend is not alive, cannot run seeder',
  FAILED_TRIGGER_MCP_CLIENT_JOB: 'Failed to trigger MCP client job',

  /* --------------------------------- NETWORK --------------------------------- */
  API_ERROR: 'API error: ',
  ERROR_OCCURED: "An error occurred",
  FETCHING_MESSAGE: 'Error fetching messages:',
  FETCHING_USER: 'Error fetching users:',
  FETCHING_ITEMS: 'Error fetching items',
  LOAD_MORE_DATA: 'Failed to load more data:',
  NETWORK_ERROR: 'Network error occurred. Please try again.',
  NETWORK_OR_SERVER_ERROR: 'Network or server error occurred.',
  DELETE_ERROR: 'Delete error',

  /* ----------------------------- IMPORT / EXPORT ----------------------------- */
  IMPORT_ERROR: 'Import Error',
  EXPORT_SUCCESSFULLY: 'File Exported Successfully.',
  SEND_REPORT: 'Can you send me the report?',

  /* ----------------------------------- MISC ---------------------------------- */
  ERROR: 'Error',
  FAILED: 'Failed',
  IS_SUCCESS: 'Success',
  DELETED: 'Deleted',
  UPDATE_FAILED: 'Update failed',
  FAILED_CREATE_MENU: 'Failed to create menu',
  ORM_TYPE_REQUIRED: 'Orm Type is required!',
  ACTION_FUNCTION: (action: string) =>
    `Action function "${action}" not found.`,
  DUPLICATE_KEY: "Duplicate Key",
  ERROR_DECODING: 'Error decoding or parsing query string from local storage:',
  CREATE_MODEL: 'Failed to create Model',
  TEMPLATE_FAILED: 'Failed to create template',
  SELECT_FROMAT: 'Please Select Format',
  PARSED_FIELD: 'Failed to parse fields:',
  CODE_GENERTAE_SUCCESSFULLY: 'Code Generated Successfully',
  RESPONSE_GENERATE_CODE_HANDLER: "response generate code handler",
  KANBAN_UPDATED: "Kanban View Updated!",
  TRY_AGAIN: 'Please try again later',
  REMOVE_ROOT_NODE: "Cannot remove the root node.",
  ATTEMPT_FETCH_MESSAGE_STATUS: (queryString: string) =>
    `Attempting to fetch mq message status with query string: ${queryString}`,
  FAILED_FETCH_MESSAGE: "Failed to fetch MQ message status:",
  FAILED_CREATE_INVOICE: "Failed to create Invoice:",

  /* ----------------------------------- CRUD ---------------------------------- */
  ADD_ATLEAST_ONE_FIELD: "Please add at least one field",


  /* ----------------------------------- Validation ---------------------------------- */

  // -------------------- REQUIRED / BASIC FIELD ERRORS --------------------
  FIELD_REUQIRED: (field: string) => `${field} is required`,
  FIELD_INAVLID_FORMAT: (field: string) => `Invalid ${field} format`,
  FIELD_INVALID: (field: string) => `Invalid ${field}`,
  ENTER_VALID_FIELD: (field: string) => `Please enter a valid ${field}.`,
  FIELD_INVALID_DATA: (field: string) => `${field}  has invalid data.`,
  FIELD_MUST_MATCH: (field: string) => `${field}s must match.`,
  FIELD_ALREADY_USE: (field: string, field1: string) =>
    `${field} Already in use. Please choose a different ${field1}.`,
  FIELD_MUST_BE_AN: (field: string, type: string) =>
    `${field} must be an ${type}"`,
  REQUIRED_REALTION: 'required-relation',
  VALIDATE_SELECTION: 'valid-selection',

  // -------------------- PASSWORD VALIDATION --------------------
  PASSWORD_DO_NOT_MEET: 'Password does not meet complexity requirements',
  PASSWORD_CHARACTER: (count: Number) =>
    `Password must be at least ${count} characters`,
  PASSWORD_CONTAIN: (contain: string, type = 'letter') =>
    `Password must contain at least one ${contain} ${type}`,

  // -------------------- LENGTH VALIDATION --------------------
  FIELD_MINIMUM_CHARACTER: (field: string, characters: Number) =>
    `${field} should be at-least ${characters} characters long.`,
  FIELD_MAXIMUM_CHARACTER: (field: string, characters: Number) =>
    `${field} should not be more than ${characters} characters long.`,

  // -------------------- OTP --------------------
  OTP_CHARACTER: (count: Number) =>
    `OTP must be a ${count}-digit number`,
  OPT_RESEND : 'OTP Resent Successfully',
  OPT_SEND : 'OTP Sent Successfully',

  // -------------------- UPDATE MESSAGES --------------------
  FIELD_UPDATE: (field: string) => `${field} Updated`,
  FIELD_UPDATE_SUCCESSFULLY: (field: string) =>
    `${field} Updated Successfully`,

  // -------------------- FILE / OBJECT VALIDATION --------------------
  MUST_BE_FILE_OBJECT: (field: string) =>
    `${field}  must be a file, an object, or empty`,
  FILE_OBJECT: 'file-or-object',
  EMPTY_VALID_ARRAY: 'is-empty-or-valid-array',
  CONTAIN_EMPTY_ARRAY_OR_FILE_OBECT: (field: string) =>
    `${field} must be an empty array or contain only files/objects.`,

  // -------------------- SELECTION VALIDATION --------------------
  FIELD_MUST_HAVE_ITEM: (field: string) =>
    `${field} must have at least one item.`,
  SELECT_ATLEAST_ONE: (field: string) =>
    `You must select at least one ${field}.`,
  SELECT_VALID_FROM_DROPDOWN: (field: string) =>
    `Please select a valid ${field} from the dropdown.`,
  SELECT_ONE_OPERATION: 'Select at least one operation',

  // -------------------- JSON VALIDATION --------------------
  IS_VALID_JSON: 'is-valid-json',
  COMPUTED_FIELD_VALIDATE_JSON:
    'Computed Field Value Provider Context Value must be valid JSON',

  // -------------------- OTHER RULES --------------------
  GREATER_THAN_MIN: 'greater-than-min',
  RELATION_CASCADE: 'Relation Cascade Value is required for one-to-one relationships',
  SNAKE_CASE: (name: string) =>
    `${name} name must be in snake_case (lowercase letters, numbers, and underscores only).`,



};
